import React from "react";

import { faExclamationTriangle } from "@awesome.me/kit-4c83d50d0d/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { format } from "date-fns";

import styles from "./MeetingGuidelines.module.css";

interface NoMeetingDayProps {
	eventStartDate: Date;
	setRendered: (rendered: boolean) => void;
	noMeetingDay: string;
}

export default function NoMeetingDay({ eventStartDate, setRendered, noMeetingDay }: NoMeetingDayProps) {
	const formattedDay = format(eventStartDate, "EEEE");

	const shouldRenderPrompt = React.useMemo(() => {
		const isNoMeetingDay = formattedDay.toUpperCase() === noMeetingDay;

		return isNoMeetingDay;
	}, [formattedDay, noMeetingDay]);

	React.useEffect(() => {
		setRendered(shouldRenderPrompt);

		return () => {
			setRendered(false);
		};
	}, [setRendered, shouldRenderPrompt]);

	if (!shouldRenderPrompt) return null;

	return (
		<div className={styles.meetingPrompt}>
			<div className={styles.meetingPromptIcon}>
				<FontAwesomeIcon fixedWidth icon={faExclamationTriangle} />
			</div>
			<div>
				<div className={styles.headlineText}>Find another day for this meeting</div>
				<div className={styles.supportingText}>{formattedDay} is a no-meeting day for you.</div>
			</div>
		</div>
	);
}
